export const commReviewLocation = "/reports/exchbusiness/commreview";
